import { useUiStore } from '../hooks/ui.store'

import type { Translation } from './i18n.types'
import { getMessages } from './messages'

/** The admin language outside React (toasts, confirm flows, formatters). */
export function currentTranslation(): Translation {
  const locale = useUiStore.getState().uiLocale

  return { locale, t: getMessages(locale) }
}
